import { render } from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=template&id=e8dff306&scoped=true"
import script from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=style&index=0&id=e8dff306&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dff306"]])

export default __exports__